import { Role } from '@/constants/users/roles'
import { Permission } from '@/constants/users/permission'

export interface INavigationRoute {
  name: string;
  displayName: string;
  meta: { icon: string };
  children?: INavigationRoute[];
  requiredPermissions?: (keyof typeof Permission)[];
}

const routes = (): INavigationRoute[] => [
  {
    name: 'users',
    displayName: 'menu.users',
    meta: {
      icon: 'group',
    },
  },
  {
    name: 'players',
    displayName: 'Игроки',
    meta: {
      icon: 'group',
    },
  },
  {
    name: 'roles',
    displayName: 'Роли',
    meta: {
      icon: 'settings',
    },
  },
  {
    name: 'promocodes',
    displayName: 'Промокоды',
    meta: {
      icon: 'settings',
    },
  },
  {
    name: 'complaints',
    displayName: 'Жалобы',
    requiredPermissions: 'complaints.view',
    meta: {
      icon: 'settings',
    },
  },
  {
    name: 'notifications',
    displayName: 'Уведомления',
    meta: {
      icon: 'settings',
    },
  },
  {
    name: 'settings',
    displayName: 'menu.settings',
    meta: {
      icon: 'settings',
    },
  },
];

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: routes(),
};
